import { Injectable } from '@angular/core';
import { ENDPOINTS } from './endpoints';

@Injectable({
    providedIn: 'root',
})
export class Globals {
    private endpoints: any = ENDPOINTS;
    /**
     * Basic URL Join
     * Joins Endpoints BaseURL with endpoint
     */
    urlJoin = (
        category: string,
        endpoint: string,
        ...args: string[]
    ): string => {
        const generatedEndpoint = `${this.endpoints[category][endpoint]}${args.join('/')}`;
        // generatedEndpoint = environment.url.taxonomy+'/'+generatedEndpoint;
        return generatedEndpoint;
    };

    urlJoinWithParam = (category: string, endpoint: string, param: string) => {
        const generatedEndpoint = `${this.endpoints[category][endpoint].pathA}${param}${this.endpoints[category][endpoint].pathB}`;
        // generatedEndpoint = environment.url.taxonomy+'/'+generatedEndpoint;
        return generatedEndpoint;
    };
}
